import { useState, useEffect, useRef } from 'react';

const ImageCompare = ({ beforeImage, afterImage }) => {
  const [isResizing, setIsResizing] = useState(false);
  const [position, setPosition] = useState(50);
  const containerRef = useRef(null);

  const handleMove = (e) => {
    if (!isResizing) return;

    const container = containerRef.current;
    const rect = container.getBoundingClientRect();
    
    let clientX;
    if (e.type === 'touchmove') {
      clientX = e.touches[0].clientX;
    } else {
      clientX = e.clientX;
    }

    const position = ((clientX - rect.left) / rect.width) * 100;
    setPosition(Math.min(Math.max(position, 0), 100));
  };

  useEffect(() => {
    const handleUp = () => setIsResizing(false);
    window.addEventListener('mouseup', handleUp);
    window.addEventListener('touchend', handleUp);
    return () => {
      window.removeEventListener('mouseup', handleUp);
      window.removeEventListener('touchend', handleUp);
    };
  }, []);

  useEffect(() => {
    if (isResizing) {
      window.addEventListener('mousemove', handleMove);
      window.addEventListener('touchmove', handleMove);
      return () => {
        window.removeEventListener('mousemove', handleMove);
        window.removeEventListener('touchmove', handleMove);
      };
    }
  }, [isResizing]);

  return (
    <div 
      ref={containerRef}
      className="relative w-full h-full overflow-hidden rounded-[2.5rem] select-none"
      onMouseDown={() => setIsResizing(true)}
      onTouchStart={() => setIsResizing(true)}
    >
      {/* Low Resolution Image */}
      <img
        src={beforeImage}
        alt="Low Resolution"
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
      
      {/* High Resolution Image with Clip Path */}
      <img
        src={afterImage}
        alt="High Resolution"
        className="absolute top-0 left-0 w-full h-full object-cover"
        style={{
          clipPath: `inset(0 0 0 ${position}%)`
        }}
      />

      {/* Slider Handle */}
      <div
        className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize"
        style={{ left: `${position}%` }}
      >
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center">
          <div className="w-6 h-6 rounded-full bg-[#0A84FF] transform transition-transform group-hover:scale-110" />
        </div>
      </div>

      {/* Labels */}
      <div className="absolute bottom-4 left-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
        Low Resolution
      </div>
      <div className="absolute bottom-4 right-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
        High Resolution
      </div>
    </div>
  );
};

export default ImageCompare; 